<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white; text-align:   center; margin-bottom: 10px">
    Occupational Therapy (OT)
  </h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: cover; border-radius: 10px"
      src="assets/img/school/news/8.jpeg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <p  style=" color: white;">
          Occupational Therapists (OT) work for children with special needs to
          help them develop functional skills for everyday life in the areas of
          self-care, life skills, school work and play. All children who attend
          Proyash-Chattogram have access to Occupational Therapy services if
          these are required. <br />
          Occupational Therapy specialist team uses standardized tools for
          assessment and draw up goals to provide evidence-based therapy and
          training for students in the following areas: <br />
          <br />
          1. Developmental skills. <br />
          2. Play skills. <br />
          3. Self-care and life skills. <br />
          4. Sensory processing skills. <br />
          5. Fine motor skills including handwriting, typing and recording work
          in class. <br />
          6. Gross motor and coordination skills. <br />
          7. Visual perception skills. <br />
          These assessments are carried out by observing the student in the
          classroom and playground and obtaining information from parents and
          the teaching staff. <br />
          Occupational Therapy inputs are provided in the form of individual
          therapy sessions, classroom programs are delivered by the class team,
          setting up home activities.
        </p>
      </div>
    </div>
  </div>
</div>
